export class CatalogNodeDragService {
  constructor(
    // $http,
    FilterResource,
    FiltersService,
    LayoutService
  ) {
    // this.CurrentFilterService = CurrentFilterService;
    this.passedElement = null;
    this.FilterResource = FilterResource;
    this.FiltersService = FiltersService;
    this.layout = LayoutService;
    // this.$http = $http;
    this.dropHistory = {
      currentIndex: -1,
      positions: []
    };

  }

  reDo() {
    if (!this.layout.editCatalog) return false;
    if (this.dropHistory.currentIndex >= this.dropHistory.positions.length - 1) return;
    this.dropHistory.currentIndex += 1;
    this.moveFilterCtrlZ(this.dropHistory.positions[this.dropHistory.currentIndex].target);
  }

  unDo() {
    if (!this.layout.editCatalog) return false;
    if (this.dropHistory.currentIndex < 0) return;
    this.moveFilterCtrlZ(this.dropHistory.positions[this.dropHistory.currentIndex].src);
    this.dropHistory.currentIndex -= 1;
  }

  keyUp(event) {
    if (event.ctrlKey && event.keyCode === 90) {
      if (event.shiftKey) this.reDo();
      else this.unDo();
    }
  }

  moveFilterCtrlZ(position) {
    if (!this.layout.editCatalog) return false;
    this.FilterResource.changePosition(position.id, position.prev_id, position.parent_id)
      .then(({
        data,
        status
      }) => {
        const parentFilter = this.FiltersService.find(f => f.children.some(fl => fl.id === position.id));
        const srcList = parentFilter ? parentFilter.children : this.FiltersService.filters;
        let srcIndex = srcList.findIndex(f => f.id === position.id);

        const targetList = position.parent_id ? this.FiltersService.findById(position.parent_id).children : this.FiltersService.filters;
        const targetIndex = position.prev_id ? targetList.findIndex(f => f.id === position.prev_id) + 1 : 0;

        targetList.splice(targetIndex, 0, srcList[srcIndex]);
        if (targetList === srcList && targetIndex <= srcIndex) srcIndex += 1;
        srcList.splice(srcIndex, 1);
      })
      .catch(({
        data,
        status
      }) => {
        console.error(status, data);
        this.setDragoverClass(this.passedElement, false);
        return false;
      });
  }


  hasFlterSachList(filrer, list) {
    let res = false;
    const iter = (children, list) => {
      if (children === list) {
        res = true;
        return true;
      }
      return children.some(f => iter(f.children, list));
    };
    iter(filrer.children, list);
    return res;
  }


  onDrop(srcList, srcIndex, target, targetIndex, parentId) {
    if (!this.layout.editCatalog) return false;
    if (!this.passedElement || targetIndex === -1 ||
      srcList[srcIndex].children === target.list ||
      this.hasFlterSachList(srcList[srcIndex], target.list)
    ) {
      this.setDragoverClass(this.passedElement, false);
      return false;
    }

    const position = {
      id: srcList[srcIndex].id
    };

    let positionList = target.list;
    let positionIndex = targetIndex;
    const id = Number.parseInt(this.passedElement.id, 0);
    if (Number.isInteger(id)) {
      let filter = null;
      positionList.some(fl => {
        if (fl.id === id) {
          filter = fl;
          return true;
        }
        return false;
      });
      if (!filter || !filter.isContainer || srcList[srcIndex] === filter) {
        this.setDragoverClass(this.passedElement, false);
        return false;
      }
      positionList = filter.children;
      positionIndex = filter.children.length;

      position.parent_id = filter.id;
      position.prev_id = positionIndex ? positionList[positionIndex - 1].id : null;
    } else {
      position.parent_id = target.id;
      if (srcList === positionList && positionIndex - 1 === srcIndex)
        position.prev_id = null;
      else
        position.prev_id = positionIndex ? positionList[positionIndex - 1].id : null;
    }
    if (position.prev_id === position.id) return false;
    this.FilterResource.changePosition(position.id, position.prev_id, position.parent_id)
      .then(({
        data,
        status
      }) => {
        // save of history
        this.dropHistory.currentIndex += 1;
        this.dropHistory.positions.splice(this.dropHistory.currentIndex, this.dropHistory.positions.length);

        const parentFilter = this.FiltersService.find(f => f.children === srcList);
        this.dropHistory.positions.push({
          src: {
            id: position.id,
            prev_id: srcIndex ? srcList[srcIndex - 1].id : null,
            parent_id: parentFilter ? parentFilter.id : null,
          },
          target: {
            id: position.id,
            prev_id: position.prev_id,
            parent_id: position.parent_id,
          }
        });
        positionList.splice(positionIndex, 0, srcList[srcIndex]);
        if (srcList === positionList && positionIndex <= srcIndex) srcIndex++;
        // delete filter from old position
        srcList.splice(srcIndex, 1);
        this.currentDragOver = -1;
        this.setDragoverClass(this.passedElement, false);
        this.passedElement = null;
      })
      .catch(({
        data,
        status
      }) => {
        console.error(status, data);
        this.setDragoverClass(this.passedElement, false);
        return false;
      });
    // */
    return true;
  }

  setDragoverClass(element, isSet) {
    if (!element) return;

    if (element.classList.contains('dndPlaceholder')) {
      if (isSet) element.classList.remove('no-display');
      else element.classList.add('no-display');
      return;
    }

    if (isSet) {
      element.classList.add('catalog-dragover');
      element.classList.remove('catalog-normal');
    } else {
      element.classList.add('catalog-normal');
      element.classList.remove('catalog-dragover');
    }
  }

  dragoverCallback(event, targetList, targetIndex, callback) {
    if (!this.layout.editCatalog) return false;
    // if (this.srcList === targetList && this.srcIndex === targetIndex) return false;
    const hidePlaceholder = (this.passedElement === event.target) ||
      (targetList[targetIndex] && !targetList[targetIndex]) ||
      (this.srcList === targetList && (this.srcIndex === targetIndex || this.srcIndex + 1 === targetIndex));
    if (event.target.classList.contains('dndPlaceholder')) {
      this.setDragoverClass(this.passedElement, false);
      this.passedElement = event.target;

      this.setDragoverClass(this.passedElement, true);
      return true;
    }
    const dndPlaceholder = event.target.closest('div[dnd-list]').querySelector('li.dndPlaceholder');
    if (dndPlaceholder) {
      if (hidePlaceholder) {
        dndPlaceholder.style.height = '0';
        dndPlaceholder.style.display = 'none';
      } else {
        dndPlaceholder.style.height = '25px';
        dndPlaceholder.style.display = 'block';
      }
    }
    const targetElement = event.target.closest('div.catalog-node-header');
    if (targetElement && this.passedElement !== targetElement) {
      this.setDragoverClass(this.passedElement, false);
      this.passedElement = targetElement;
      this.currentDragOver = targetIndex;
      if (targetElement.getAttribute('iscontainer') !== 'true') return false;

      this.setDragoverClass(this.passedElement, true);
    }
    return true;
  }

  dragStart(srcIndex, srcList) {
    this.srcIndex = srcIndex;
    this.srcList = srcList;
    this.passedElement = document.querySelector(`sc-catalog [id='${this.srcList[srcIndex].id}']`);
  }

}



// WEBPACK FOOTER //
// ./src/filter/catalog/catalog-node-drag.service.js